import { Container, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
// @ts-ignore
import AppLogo from "../ui-components/app-logo";
import { AppConst } from "../common/app-constants.ts";

export default function TermsAndConditionsPage() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <AppLogo />
      <Typography variant="h4" gutterBottom>
        Terms and Conditions
      </Typography>

      <SectionHeading>Welcome to {AppConst.APP_NAME}!</SectionHeading>
      <Typography paragraph>
        These terms and conditions outline the rules and regulations for the use
        of Substring LLC's application.
      </Typography>
      <Typography paragraph>
        By accessing this website we assume you accept these terms and
        conditions. Do not continue to use {AppConst.APP_NAME} if you do not agree to take
        all of the terms and conditions stated on this page.
      </Typography>
      <Typography paragraph>
        The following terminology applies to these Terms and Conditions, Privacy
        Statement and Disclaimer Notice and all Agreements: "Client", "You" and
        "Your" refers to you, the person log on this website and compliant to the
        Company's terms and conditions. "The Company", "Ourselves", "We", "Our"
        and "Us", refers to our Company. "Party", "Parties", or "Us", refers to
        both the Client and ourselves. All terms refer to the offer, acceptance
        and consideration of payment necessary to undertake the process of our
        assistance to the Client in the most appropriate manner for the express
        purpose of meeting the Client's needs in respect of provision of the
        Company's stated services, in accordance with and subject to, prevailing
        law of Netherlands. Any use of the above terminology or other words in
        the singular, plural, capitalization and/or he/she or they, are taken as
        interchangeable and therefore as referring to same.
      </Typography>

      <SectionHeading>Cookies</SectionHeading>
      <Typography paragraph>
        We employ the use of cookies. By accessing {AppConst.APP_NAME}, you agreed to use
        cookies in agreement with the Substring LLC's Privacy Policy.
      </Typography>
      <Typography paragraph>
        Most interactive websites use cookies to let us retrieve the user's
        details for each visit. Cookies are used by our website to enable the
        functionality of certain areas to make it easier for people visiting our
        website. Some of our affiliate/advertising partners may also use cookies.
      </Typography>

      <SectionHeading>License</SectionHeading>
      <Typography paragraph>
        Unless otherwise stated, Substring LLC and/or its licensors own the
        intellectual property rights for all material on {AppConst.APP_NAME}. All
        intellectual property rights are reserved. You may access this from
        {AppConst.APP_NAME} for your own personal use subjected to restrictions set in these
        terms and conditions.
      </Typography>
      <Typography paragraph>You must not:</Typography>
      <BulletList
        items={[
          `Republish material from ${AppConst.APP_NAME}`,
          `Sell, rent or sub-license material from ${AppConst.APP_NAME}`,
          `Reproduce, duplicate or copy material from ${AppConst.APP_NAME}`,
          `Redistribute content from ${AppConst.APP_NAME}`,
        ]}
      />
      <Typography paragraph>
        This Agreement shall begin on the date hereof.
      </Typography>

      <SectionHeading>Comments Section</SectionHeading>
      <Typography paragraph>
        Parts of this website offer an opportunity for users to post and exchange
        opinions and information in certain areas of the website. Substring LLC
        does not filter, edit, publish or review Comments prior to their presence
        on the website. Comments do not reflect the views and opinions of
        Substring LLC, its agents and/or affiliates. Comments reflect the views
        and opinions of the person who post their views and opinions. To the
        extent permitted by applicable laws, Substring LLC shall not be liable
        for the Comments or for any liability, damages or expenses caused and/or
        suffered as a result of any use of and/or posting of and/or appearance of
        the Comments on this website.
      </Typography>
      <Typography paragraph>
        Substring LLC reserves the right to monitor all Comments and to remove
        any Comments which can be considered inappropriate, offensive or causes
        breach of these Terms and Conditions.
      </Typography>
      <Typography paragraph>You warrant and represent that:</Typography>
      <BulletList
        items={[
          "You are entitled to post the Comments on our website and have all necessary licenses and consents to do so",
          "The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party",
          "The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy",
          "The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity",
        ]}
      />
      <Typography paragraph>
        You hereby grant Substring LLC a non-exclusive license to use, reproduce,
        edit and authorize others to use, reproduce and edit any of your Comments
        in any and all forms, formats or media.
      </Typography>

      <SectionHeading>Hyperlinking to our Content</SectionHeading>
      <Typography paragraph>
        The following organizations may link to our Website without prior written
        approval:
      </Typography>
      <BulletList
        items={[
          "Government agencies",
          "Search engines",
          "News organizations",
          "Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses",
          "System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site",
        ]}
      />
      <Typography paragraph>
        These organizations may link to our home page, to publications or to
        other Website information so long as the link: (a) is not in any way
        deceptive; (b) does not falsely imply sponsorship, endorsement or
        approval of the linking party and its products and/or services; and (c)
        fits within the context of the linking party's site.
      </Typography>
      <Typography paragraph>
        We may consider and approve other link requests from the following types
        of organizations:
      </Typography>
      <BulletList
        items={[
          "commonly-known consumer and/or business information sources",
          "dot.com community sites",
          "associations or other groups representing charities",
          "online directory distributors",
          "internet portals",
          "accounting, law and consulting firms",
          "educational institutions and trade associations",
        ]}
      />
      <Typography paragraph>
        We will approve link requests from these organizations if we decide that:
        (a) the link would not make us look unfavorably to ourselves or to our
        accredited businesses; (b) the organization does not have any negative
        records with us; (c) the benefit to us from the visibility of the
        hyperlink compensates the absence of Substring LLC; and (d) the link is
        in the context of general resource information.
      </Typography>
      <Typography paragraph>
        Approved organizations may hyperlink to our Website by use of our
        corporate name, by use of the uniform resource locator being linked to,
        or by use of any other description of our Website being linked to that
        makes sense within the context and format of content on the linking
        party's site. No use of Substring LLC's logo or other artwork will be
        allowed for linking absent a trademark license agreement.
      </Typography>

      <SectionHeading>iFrames</SectionHeading>
      <Typography paragraph>
        Without prior approval and written permission, you may not create frames
        around our Webpages that alter in any way the visual presentation or
        appearance of our Website.
      </Typography>

      <SectionHeading>Content Liability</SectionHeading>
      <Typography paragraph>
        We shall not be held responsible for any content that appears on your
        Website. You agree to protect and defend us against all claims that is
        rising on your Website. No link(s) should appear on any Website that may
        be interpreted as libelous, obscene or criminal, or which infringes,
        otherwise violates, or advocates the infringement or other violation of,
        any third party rights.
      </Typography>

      <SectionHeading>Your Privacy</SectionHeading>
      <Typography paragraph>Please read our Privacy Policy.</Typography>

      <SectionHeading>Reservation of Rights</SectionHeading>
      <Typography paragraph>
        We reserve the right to request that you remove all links or any
        particular link to our Website. You approve to immediately remove all
        links to our Website upon request. We also reserve the right to amend
        these terms and conditions and its linking policy at any time. By
        continuously linking to our Website, you agree to be bound to and follow
        these linking terms and conditions.
      </Typography>

      <SectionHeading>Removal of links from our website</SectionHeading>
      <Typography paragraph>
        If you find any link on our Website that is offensive for any reason, you
        are free to contact and inform us any moment. We will consider requests
        to remove links but we are not obligated to or so or to respond to you
        directly.
      </Typography>
      <Typography paragraph>
        We do not ensure that the information on this website is correct, we do
        not warrant its completeness or accuracy; nor do we promise to ensure
        that the website remains available or that the material on the website is
        kept up to date.
      </Typography>

      <SectionHeading>Disclaimer</SectionHeading>
      <Typography paragraph>
        To the maximum extent permitted by applicable law, we exclude all
        representations, warranties and conditions relating to our website and
        the use of this website. Nothing in this disclaimer will:
      </Typography>
      <BulletList
        items={[
          "limit or exclude our or your liability for death or personal injury",
          "limit or exclude our or your liability for fraud or fraudulent misrepresentation",
          "limit any of our or your liabilities in any way that is not permitted under applicable law",
          "exclude any of our or your liabilities that may not be excluded under applicable law",
        ]}
      />
      <Typography paragraph>
        The limitations and prohibitions of liability set in this Section and
        elsewhere in this disclaimer: (a) are subject to the preceding paragraph;
        and (b) govern all liabilities arising under the disclaimer, including
        liabilities arising in contract, in tort and for breach of statutory
        duty.
      </Typography>
      <Box sx={{ mb: 4 }}>
        <Typography paragraph>
          As long as the website and the information and services on the website
          are provided free of charge, we will not be liable for any loss or
          damage of any nature.
        </Typography>
      </Box>
    </Container>
  );
}

function SectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
      {children}
    </Typography>
  );
}

function BulletList({ items }: { items: string[] }) {
  return (
    <List dense disablePadding sx={{ pl: 2, mb: 1 }}>
      {items.map((item, i) => (
        <ListItem key={i} sx={{ display: "list-item", listStyleType: "disc", pl: 0 }}>
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </List>
  );
}
